import { render, staticRenderFns } from "./AdminChurnRisk.vue?vue&type=template&id=79c232c4&scoped=true"
import script from "./AdminChurnRisk.vue?vue&type=script&lang=js"
export * from "./AdminChurnRisk.vue?vue&type=script&lang=js"
import style0 from "./AdminChurnRisk.vue?vue&type=style&index=0&id=79c232c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c232c4",
  null
  
)

export default component.exports